import { QRCodeSVG } from 'qrcode.react';
import { useState } from 'react';
import { COPY_RESET_MS } from '@nudge/shared';
import { toast } from '../ui/Toast';

export function InviteQR({ url }: { url: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast('Link copied', 'success');
      setTimeout(() => setCopied(false), COPY_RESET_MS);
    } catch {
      toast('Could not copy link', 'error');
    }
  }

  return (
    <div className="flex flex-col items-center gap-3 rounded-2xl border border-border-subtle bg-card p-5">
      <div className="rounded-lg bg-white p-3">
        <QRCodeSVG value={url} size={180} level="M" includeMargin={false} />
      </div>
      <code className="break-all text-center text-xs text-text-muted">{url}</code>
      <button
        onClick={copy}
        className="rounded-lg border border-border-subtle bg-surface px-4 py-2 text-sm text-text-primary"
      >
        {copied ? 'Copied!' : 'Copy link'}
      </button>
    </div>
  );
}
